export default __webpack_public_path__ + "static/media/Torpedo-1Closed.969c8d4e.jpg";